import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const Wrapper = styled.div``

export const UserList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 20px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`

export const UserElem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`

export const UserCard = styled.div`
  width: calc(100% - 30px);
`

export const UserDelete = styled.div`
  width: 30px;
`

export const ControlIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`
